// extracted by mini-css-extract-plugin
module.exports = {"message":"ConfirmModal_message__L4opW","buttonContainer":"ConfirmModal_buttonContainer__PgTT2","confirm":"ConfirmModal_confirm__HpJ2r"};